import React from "react";
import { IconButton, IconButtonProps, Tooltip, alpha } from "@mui/material";
import { tokens } from "../../theme";

export interface TableActionButtonProps extends IconButtonProps {
  title: string;
  variant?: "default" | "primary" | "danger" | "success" | "warning";
}

const variantStyles: Record<
  NonNullable<TableActionButtonProps["variant"]>,
  object
> = {
  primary: {
    color: "primary.main",
    "&:hover": { bgcolor: alpha(tokens.colors.primary.main, 0.08) },
  },
  danger: {
    color: "error.main",
    "&:hover": { bgcolor: alpha(tokens.colors.error.main, 0.08) },
  },
  success: {
    color: "success.main",
    "&:hover": { bgcolor: alpha(tokens.colors.success.main, 0.08) },
  },
  warning: {
    color: "warning.main",
    "&:hover": { bgcolor: alpha(tokens.colors.warning.main, 0.08) },
  },
  default: {
    color: "text.secondary",
    "&:hover": { bgcolor: "action.hover" },
  },
};

const TableActionButton: React.FC<TableActionButtonProps> = ({
  title,
  variant = "default",
  sx,
  ...props
}) => {
  const colorSx = variantStyles[variant];

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        {...props}
        sx={{
          width: 32,
          height: 32,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: tokens.radius.sm,
          ...colorSx,
          ...sx,
        }}
      />
    </Tooltip>
  );
};

export default TableActionButton;
